import { render, staticRenderFns } from "./tabNav.vue?vue&type=template&id=3f418809&"
import script from "./tabNav.vue?vue&type=script&lang=js&"
export * from "./tabNav.vue?vue&type=script&lang=js&"
import style0 from "./tabNav.vue?vue&type=style&index=0&id=3f418809&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports